export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/audioRecorder.worker.a7bfaa3f.worker.js");
}
